import * as React from 'react';
import { SVGProps } from 'react';

const SvgCube = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#cube_svg__a)'>
      <path
        d='M21.618 6.233 12.388 1.1a.798.798 0 0 0-.776 0l-9.23 5.133a.752.752 0 0 0-.28.268.707.707 0 0 0-.102.366v10.266c0 .129.035.254.102.366a.752.752 0 0 0 .28.268l9.23 5.133a.798.798 0 0 0 .776 0l9.23-5.133a.752.752 0 0 0 .28-.268.707.707 0 0 0 .102-.366V6.867a.707.707 0 0 0-.102-.366.752.752 0 0 0-.28-.268ZM12 2.583l7.704 4.284L12 11.15 4.296 6.867 12 2.582Zm-8.462 5.56 7.693 4.278v8.569l-7.693-4.278V8.144ZM12.77 20.99V12.42l7.693-4.277v8.568l-7.693 4.278Z'
        fill='#000'
      />
    </g>
    <defs>
      <clipPath id='cube_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgCube;
